import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import ImageScroll from "../components/home/ImageScroll";
import StoryTeaser from "../components/home/StoryTeaser";
import WeddingStyles from "../components/home/WeddingStyles";
import Process from "../components/home/Process";
import BudgetEstimator from "../components/home/BudgetEstimator";
import SampleProposal from "../components/home/SampleProposal";
import Stories from "../components/home/Stories";
import LatestWork from "../components/home/LatestWork";
import WhyBigWedd from "../components/home/WhyBigWedd";
import InstagramFeed from "../components/home/InstagramFeed";
import CTASection from "../components/home/CTASection";
import { Marquee, useTitle } from "../components/shared";

export default function Home() {
  useTitle("The Big Wedd | Luxury Wedding & Event Planners — Jaipur · Udaipur · Goa · Rishikesh");
  return (
    <main>
      <Hero />
      <Marquee items={["Jaipur", "Udaipur", "Goa", "Rishikesh", "Destination Weddings", "Luxury Celebrations", "India & Abroad"]} />
      <Stats />
      <ImageScroll />
      <StoryTeaser />
      <WeddingStyles />
      <Process />
      <BudgetEstimator />
      <SampleProposal />
      <Stories />
      <LatestWork />
      <WhyBigWedd />
      <InstagramFeed />
      <CTASection />
    </main>
  );
}
